import { useState, useRef } from "react";
import { Camera, Loader2, X } from "lucide-react";
import api, { apiError, API } from "@/lib/api";
import { toast } from "sonner";

export function PhotoUpload({ value = [], onChange, label = "Photos", testid = "photo-upload", multiple = true }) {
  const [busy, setBusy] = useState(false);
  const ref = useRef();

  const handleFiles = async (files) => {
    setBusy(true);
    try {
      const paths = [];
      for (const file of Array.from(files)) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        paths.push(data.path);
      }
      onChange(multiple ? [...value, ...paths] : paths.slice(-1));
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  const remove = (p) => onChange(value.filter((x) => x !== p));

  return (
    <div>
      <p className="mb-2 text-sm font-medium text-slate-700">{label}</p>
      <div className="flex flex-wrap gap-3">
        {value.map((p) => (
          <div key={p} className="relative h-20 w-20 overflow-hidden rounded-lg border border-slate-200">
            <img src={`${API}/files/${p}`} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => remove(p)} className="absolute right-0 top-0 rounded-bl bg-black/60 p-0.5 text-white">
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
        <button
          type="button"
          data-testid={testid}
          onClick={() => ref.current?.click()}
          className="flex h-20 w-20 flex-col items-center justify-center gap-1 rounded-lg border-2 border-dashed border-slate-300 text-slate-400 hover:border-[#1D9BF0] hover:text-[#1D9BF0]"
        >
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Camera className="h-5 w-5" />}
          <span className="text-[10px]">Ajouter</span>
        </button>
      </div>
      <input ref={ref} type="file" accept="image/*" capture="environment" multiple={multiple} className="hidden" onChange={(e) => e.target.files && handleFiles(e.target.files)} />
    </div>
  );
}
